import axiosPost from '../axiosPost';

export const serieDeFeriadosDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "FeriadoSerieDel",
        "params": {
            "feriadoSerieId": id
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}